import React, { useState, useEffect } from 'react';
import Link from '@mui/material/Link';
import axios from 'axios';
import { useToasts } from 'react-toast-notifications';
import { useParams, useHistory } from 'react-router-dom';
import { domain } from '../../Variables/domain';

export default function EditRate() {
  const history = useHistory();

  const { id } = useParams();

  useEffect(() => {
    const fetchData = async () => {
      const resp = await axios.get(`${domain}/rate/get/` + id);
      setRatePrice(resp.data.rate);
    };

    // call the function
    fetchData();
  }, [id]);

  const { addToast } = useToasts();

  const updateRate = async (id) => {
    try {
      history.replace('/dashboard/overview');
      await axios.patch(`${domain}/rate/update/` + id, { rate: ratePrice });
      addToast('ແກ້ໄຂເລດເງິນສໍາເລັດ', {
        appearance: 'success',
      });
      history.go(0);
    } catch (error) {
      addToast('ທ່ານໃຊ້ເງິນເລດນີ້ຢູ່ແລ້ວ', {
        appearance: 'error',
      });
    }
  };

  const [ratePrice, setRatePrice] = useState('');

  return (
    <div className="flex justify-center">
      <form className="modelCard py-4 h-fit" action="">
        <Link
          href="/dashboard/overview"
          className="w-full bg-[#ca1541] shadow-sm mb-8 text-white px-4 py-2 text-lg no-underline font-semibold rounded-sm text-center"
        >
          ຍົກເລິກການແກ້ໄຂ
        </Link>
        <label className="modalLabel mb-2">ເລດເງິນ/ນາທີ</label>
        <input
          className="modalInput mb-2"
          type="text"
          defaultValue={ratePrice}
          placeholder="ໃສ່ຊື່ບັດ"
          onChange={(event) => {
            setRatePrice(event.target.value);
          }}
        />
        <button className="modalBtn rounded-sm" onClick={() => updateRate(id)}>
          ແກ້ໄຂເລດເງິນ
        </button>
      </form>
    </div>
  );
}
